import React from 'react';
import { Link } from 'react-router-dom';
import { PlusCircleIcon } from '@heroicons/react/24/outline';

const ActionCard = ({ title, description, icon: Icon, linkTo, buttonText }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center mb-4">
        <Icon className="h-6 w-6 text-primary-600 mr-2" />
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
      </div>
      <p className="text-gray-600 mb-4">{description}</p>
      <Link
        to={linkTo}
        className="btn-primary inline-flex items-center"
      >
        <PlusCircleIcon className="h-5 w-5 mr-1" />
        {buttonText}
      </Link>
    </div>
  );
};

export default ActionCard;